import { render, staticRenderFns } from "./ListingDescription.vue?vue&type=template&id=0bb052f4&"
import script from "./ListingDescription.vue?vue&type=script&lang=js&"
export * from "./ListingDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports